export default "__VITE_ASSET__D763xdcl__"